

export class ExpenseTypeOutputWithStatus implements IExpenseTypeOutputWithStatus {
    /** The auto-generated id of the expense type  master */
    expense_type_id!: number;
    /** The expense type name with 255 character limit */
    expense_type_name!: string;
    /** Manage status of expense type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IExpenseTypeOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expense_type_id = _data["expense_type_id"];
            this.expense_type_name = _data["expense_type_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ExpenseTypeOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTypeOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expense_type_id"] = this.expense_type_id;
        data["expense_type_name"] = this.expense_type_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IExpenseTypeOutputWithStatus {
    /** The auto-generated id of the expense type  master */
    expense_type_id: number;
    /** The expense type name with 255 character limit */
    expense_type_name: string;
    /** Manage status of expense type. 0 For De-active, 1 For Active */
    status: number;
}

